import { sendSignedRequest } from './signed-request';

import type { ProfileBody, ProfileView } from './types';

/**
 * `/profile/0/mine` — 경로의 `0` 은 실제 id 가 아니라 캐치올 라우트(`/{type}/{id}/{cmd}`)의
 * 자리채움이다. 클라이언트는 id 를 다루지 않고 `mine` 으로만 접근한다.
 *
 * `register-device` 와 달리 **서명 요청**이다 — 세션이 없으면 서버가 `403 NOT ALLOWED`
 * 로 끊는다. 그 403 은 고장이 아니라 부팅 순서라, 재시도 판정은 `profile-sync` 가 한다.
 * 실패를 상태코드 실은 에러로 세우는 일은 `signed-request` 가 한다.
 */
const MINE_PATH = '/profile/0/mine';

/** 세션 유저의 프로필. 서버가 get-or-create 라 아직 안 채운 사람에게도 빈 뷰가 온다. */
export const getProfile = (): Promise<ProfileView> =>
  sendSignedRequest<ProfileView>({ method: 'GET', path: MINE_PATH });

/** 온보딩 응답을 세션 유저의 프로필에 기록한다. 화이트리스트 밖 키는 서버가 버린다. */
export const putProfile = (body: ProfileBody): Promise<ProfileView> =>
  sendSignedRequest<ProfileView>({ method: 'PUT', path: MINE_PATH, body });
